import { put, call } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
// Actions
import {
  reportsMainGenerateReportProgress,
  reportsMainGenerateReportUpdate
} from 'Redux/actions';

import {
  getTimeZone,
  getCategoryFilter,
  handleAsyncReport,
  baseReportConditions,
  generateReportInstance,
  isJsonFormat
} from 'Modules/reports/views/main/components/reportsTab/helper';

import {
  getAbbvTimezone
} from "./../../../../../../../../../components/uiControls/Timezone/tools";

function* getFSMCombinedReportV2(report, page, rowsPerPage, sortField, sortOrder, requestFlag) {
  const { timeZone, sendByEmail, emailsTo, name, timeframeName, categoryName, delayed, dataResultPath } = report;
  const { filterType, filterArray, startRange, endRange, unitsSelected,otherFilters, accumulateData = true, dates } = report.filters
  const baseConditionsQuery = baseReportConditions({ report, name, dataResultPath, timeZone, delayed, unitsSelected, timeframeName, filterType, filterArray, categoryName, startRange, endRange, dates })
  try {
    let payload = {
      conditions: {
        ...baseConditionsQuery
      },
      limit: rowsPerPage,
      offset: page
    };

    const columnDriverCSV = report?.exportType === "csv" ? [ {
      "column": "driverName",
      "header": "Driver"
    }] : []

    if (report.export) {
      
      payload = {
        ...payload,
        limit: isJsonFormat(report?.exportType, dataResultPath) ? rowsPerPage : 1000,
        offset: isJsonFormat(report?.exportType, dataResultPath) ? page : 1,
        conditions: {
          ...payload.conditions,
          exportOptions: {
            sendByEmail,
            emailsTo,
            format: {
              fileFormat: report?.exportType || "json",
              formatOptions: "{\"addPagination\": \"true\", \"addLogo\": \"true\", \"addLine\": \"true\", \"rowPageBreak\": \"avoid\"}",
              durationFormat: report?.durationFormat
            },
            culture: report.lang,
            timeZone: getTimeZone(timeZone),
            folderName: "px-customer-reports",
            filePrefixName: "fsmCombinedReportV2",
            columns: [
              ...columnDriverCSV,
              {
                column: `${report?.exportType === "csv" ? "dateTime" : "time"}`,
                header: `${report?.exportType === "csv" ? `Time & Date (${getAbbvTimezone(timeZone)})` : `Time`}`
              },
              {
                column: "driverStatus",
                header: "Driver Status"
              },
              {
                column: "address",
                header: "Address"
              },
              {
                column: "messageDirection",
                header: "Chat To/From"
              },
              {
                column: "message",
                header: "Message"
              },
              {
                column: "stopTitle",
                header: "Stop Title"
              },
              {
                column: "stopStatus",
                header: "Stop Status"
              }
            ]
          }
        }
      }
    }
    
    let data = yield call(
      clientQuery,
      `query getCombinedReportV2 ($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
        Report: getCombinedReportV2 (conditions: $conditions, limit: $limit, offset: $offset) {
          ${generateReportInstance(report.export, dataResultPath, report.exportFromTable) ?
        `reportInstanceId`
        : `
            items {
              recordInfo {
                entityId
                entityLabel
                tagId
                tagLabel
                startDate
                endDate
                recordType
                groupLabel
                groupIndex
                groupTotal
                groupTagColor
              }
              recordDetail {
                id
                driverName
                noData
                driverId
                dateTime
                driverStatus
                inOut
                address
                messageDirection
                message
                stopTitle
                stopStatus
                latitude
                longitude
                date
              }
            }
            total
            limit
            offset
            category
        `}
        }
        
      }`,
      payload,
      endpoints.GRAPHQL_PX_REPORTING,
    );
    yield handleAsyncReport(report, data, accumulateData);

  } catch (exc) {
    ExceptionManager(exc, 'reports/getFSMCombinedReportV2', 'getFSMCombinedReportV2');
    report.loading = false
    yield put(reportsMainGenerateReportProgress(report))
    if (!requestFlag) {
      let flag = true
      yield put(reportsMainGenerateReportUpdate(report, page, rowsPerPage, sortField, sortOrder, flag))
    } else {
      report.loading = false
      yield put(reportsMainGenerateReportProgress(report))
    }
  }
}


export default getFSMCombinedReportV2;
